module.exports = "/assets/review_normal.webp"